var map = {
	"./BasisGrotesquePro-Black.woff": 704,
	"./BasisGrotesquePro-Light.woff": 706,
	"./BasisGrotesquePro-Regular.woff": 708,
	"./CaslonGraD.woff": 710,
	"./CircularPro-Black.woff": 713,
	"./CircularPro-BlackItalic.woff": 716,
	"./CircularPro-Bold.woff": 719,
	"./CircularPro-BoldItalic.woff": 722,
	"./CircularPro-Book.woff": 725,
	"./CircularPro-BookItalic.woff": 728,
	"./CircularPro-Medium.woff": 731,
	"./CircularPro-MediumItalic.woff": 734
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1188;



//////////////////
// WEBPACK FOOTER
// ./public/fonts ^\.\/.*\.woff$
// module id = 1188
// module chunks = 168707334958949